import ApiClient from './apiClient';

// Define interface for contact form data
export interface ContactFormData {
  name: string;
  email: string;
  phone: string;
  messageType: string;
  message: string;
  recaptcha_token?: string | null;
}

export interface ContactConversationData {
  conversationUuid: string;
  conversationUrl: string;
}

// API response shape (Laravel ApiResponse)
export interface ContactResponse {
  status: string;
  message?: string;
  data: ContactConversationData;
}

/**
 * Service for handling contact form operations
 */
export const ContactService = {
  /**
   * Submit a contact form
   * @param data Form data to submit
   */
  submitContactForm: (data: ContactFormData): Promise<ContactResponse> => {
    return ApiClient.post<ContactResponse, ContactFormData>('/contact-us', data);
  }
};

export default ContactService; 
